import React, { Component } from 'react';
import { DragDropContext } from 'react-dnd';
import { observer } from 'mobx-react';
import HTML5Backend from 'react-dnd-html5-backend';
import DndItem from './dnd-item';

@DragDropContext(HTML5Backend)
@observer
export default class DndContainer extends Component {
    constructor(props) {
        super(props);
        this.moveItem = this.moveItem.bind(this);
    }

    moveItem(dragIndex, hoverIndex) {
        this.props.itemStore.switchPositons(dragIndex, hoverIndex);
    }

    render() {
        const dndItems = this.props.items.map(item => {
            return (
                <DndItem
                    key={item.timelineEventId}
                    {...this.props}
                    index={item.order}
                    id={item.timelineEventId}
                    text={item.name}
                    moveItem={this.moveItem}
                    eventInstance={item}
                />
            );
        });

        return <div>{dndItems}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/dnd-container.js